export default {
	styleOverrides: {
		gutterBottom: ({ theme }) => ({
			marginBottom: theme.spacing(2),
		}),
	},
	defaultProps: {
		variantMapping: {
			body3: 'p',
		},
	},
};
